// extracted by mini-css-extract-plugin
export default {"recos":"_6-z","productCardOverride":"a7-z","rowHasBadge":"b7-z"};